import { XmlContentTypeHeader } from './TwilioWebhookRequest';
const MsgResp = require('twilio/lib/twiml/MessagingResponse');
export const DEFAULT_RESPONSE_CODE = 200;
export const EMPTY_TWIML_RESPONSE = '<?xml version="1.0" encoding="UTF-8"?><Response />';
const TwimlResponseXml = Symbol('xml');
export default class TwimlResponse {
    constructor(res) {
        this.res = res;
        this[TwimlResponseXml] = EMPTY_TWIML_RESPONSE;
    }
    get xml() {
        return this[TwimlResponseXml];
    }
    setMessage(message) {
        const msgRes = (new MsgResp());
        msgRes.message(message);
        this[TwimlResponseXml] = msgRes.toString();
        return this;
    }
    send(code = DEFAULT_RESPONSE_CODE) {
        this.res.writeHead(code, XmlContentTypeHeader);
        this.res.end(this.xml);
    }
}
